<template>
  <div
    :class="[
      'flex flex-col gap-5 py-3.75 2xl:gap-6 2xl:py-4.25',
      {
        'px-5': !!schedule.color?.length,
      },
    ]"
    :style="{ backgroundColor: `#${schedule.color}` }"
  >
    <div
      v-if="schedule.date"
      class="xl:text-1.5xl flex items-center gap-3.75 text-xl leading-[110%] xl:leading-[118%] 2xl:text-[26px]/[30px]"
    >
      <template v-if="schedule.date_to">
        <span
          >{{ normalizedDate(schedule.date) }} –
          {{ normalizedDate(schedule.date_to) }}</span
        >
      </template>
      <template v-else>
        <span>{{ normalizedDate(schedule.date) }}</span>
        <span>({{ getShortDay(schedule.date) }})</span>
      </template>
    </div>

    <div class="flex flex-col gap-3.75 2xl:gap-4.25">
      <div class="flex items-center gap-2.5">
        <TypeBadge
          v-for="tag in schedule.programTags"
          :key="tag.id"
          :text="tag.name"
        />
      </div>
      <div
        class="text-base leading-[120%] xl:text-[17px] xl:leading-[124%] 2xl:text-xl/[24px]"
        v-html="schedule.description"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Schedule } from '~/types'

interface Props {
  schedule: Schedule
}

const props = defineProps<Props>()

const { locale } = useI18n()

const getShortDay = (dateString: string) => {
  if (!dateString) return

  const date = new Date(dateString)

  if (isNaN(date.getTime())) return

  return new Intl.DateTimeFormat(locale.value === 'cs' ? 'cs-CZ' : 'en-EN', {
    weekday: 'short',
  })
    .format(date)
    .toLowerCase()
}

const normalizedDate = (dateString: string) => {
  const d = new Date(dateString)
  const day = d.getDate()
  const month = d.getMonth() + 1
  const year = d.getFullYear()
  return `${day}. ${month}.`
}
</script>
